var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.66602C5.40002 1.66602 1.66669 5.39935 1.66669 9.99935C1.66669 14.5993 5.40002 18.3327 10 18.3327C14.6 18.3327 18.3334 14.5993 18.3334 9.99935C18.3334 5.39935 14.6 1.66602 10 1.66602ZM10.8334 14.166H9.16669V9.16602H10.8334V14.166ZM10.8334 7.49935H9.16669V5.83268H10.8334V7.49935Z",
    fill: "#CBCBCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.8eb33519.svg";
export { ForwardRef as ReactComponent };